import GeneralAccountPreferencesComponent from './GeneralAccountPreferencesContainer';

export default GeneralAccountPreferencesComponent;
